import React from 'react';
import { List } from 'immutable';
var TableContext = React.createContext({
  list: List([]),
  filterRows: function filterRows() {
    return null;
  },
  filteredRows: undefined,
  sortState: undefined,
  sortBy: undefined,
  sortDirection: undefined,
  search: ''
});
export default TableContext;